var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearchDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9782 16.2682L23.4374 20.7274C24.187 21.4771 24.187 22.6925 23.4374 23.4422C22.6824 24.1788 21.4776 24.1788 20.7226 23.4422L16.2634 18.984C12.0535 21.7985 6.39517 20.9605 3.18173 17.0467C-0.0317219 13.1328 0.247823 7.41963 3.82802 3.83817C7.40821 0.256709 13.1213 -0.0248552 17.0363 3.18721C20.9513 6.39927 21.7913 12.0573 18.9782 16.2682ZM17.76 10.8048C17.76 6.96089 14.6439 3.84479 10.8 3.84479C6.95785 3.84903 3.84423 6.96265 3.84 10.8048C3.84 14.6487 6.95609 17.7648 10.8 17.7648C14.6439 17.7648 17.76 14.6487 17.76 10.8048Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 10.75,
    r: 3.75,
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchDot);
export default __webpack_public_path__ + "static/media/icon-search-dot.9b99452e4afe40096b36f0d8eb5c3330.svg";
export { ForwardRef as ReactComponent };